import { Component, Input } from '@angular/core';

@Component({
    selector: 'ui-title-container',
    templateUrl: './ui-title-container.component.html',
    styleUrls: ['./ui-title-container.component.scss'],
    standalone: false
})
export class UiTitleContainerComponent {
  @Input() title = '';
  @Input() icon: string | null = null;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() img: string | null = null;
}
